import SelectStyled from "@/components/SelectStyled";
import { usePlaylists } from "@/lib/api";
import { MenuItem, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Error from "next/error";
import TextFieldStyled from "../TextFieldStyled";

export const PlaylistSuchenFilter = ({
  playlist,
  onFilterChanged,
  onPlaylistChanged,
}) => {
  const { playlists, isLoading, isError } = usePlaylists([
    '"toplist"',
    '"curated"',
  ]);

  const handlePlaylistChanged = (event) => {
    const pl = playlists.filter((p) => p.title == event.target.value);
    if (onPlaylistChanged) {
      onPlaylistChanged(pl[0]);
    }
  };

  const setFilter = (event) => {
    if (onFilterChanged) {
      onFilterChanged(event.target.value);
    }
  };

  if (isLoading || !playlist) return <Skeleton />;
  if (isError) return <Error />;

  return (
    <Grid container spacing={{ xs: 1, sm: 3 }}>
      <Grid
        item
        xs={12}
        sx={{
          mt: 3,
          mb: 4,
          "& .MuiAutocomplete-root:not(:last-of-type)": {
            mb: 1,
          },
        }}
      >
        <TextFieldStyled
          label="Playlist durchsuchen"
          placeholder="…"
          name="filter"
          onChange={setFilter}
        />

        <SelectStyled
          name="playlist"
          label="Aktuelle Playlist"
          defaultValue={playlist.title}
          onChange={handlePlaylistChanged}
          allowEmpty={true}
        >
          {playlists.map((pl) => (
            <MenuItem value={pl.title} key={pl.id}>
              {pl.title}
            </MenuItem>
          ))}
        </SelectStyled>
      </Grid>
    </Grid>
  );
};
